module.exports = __webpack_public_path__ + "img/img-placeholder.0a6e6a4e.jpeg";